module.exports = __webpack_public_path__ + "assets/img/28_977_big.eddf129b.jpg";